/* eslint-disable no-nested-ternary */
import { CSSObject, styled } from '@mui/material';
import React from 'react';

const LabelContainer = styled('div')<{ align?: string, flush?: boolean }>(({ align, flush, theme }) => {
  const positionStyles: CSSObject = {
    height: '15px',
    width: '35px',
    position: 'absolute',
    transform: 'rotate(-90deg)',
    fontSize: '10px',
    top: '42px',
    textAlign: 'right',
    lineHeight: '16px',
  };

  if (align === 'left') {
    positionStyles.right = flush ? '4px' : '11px';
  } else if (align === 'right') {
    positionStyles.left = flush ? '5px' : '11px';
  }

  return positionStyles;
});

type Props = {
  children: React.ReactNode;
  align?: string;
  flush?: boolean;
}

function Label({ children, align, flush }: Props) {
  return (
    <LabelContainer align={align} flush={flush}>{children}</LabelContainer>
  );
}

Label.defaultProps = {
  align: 'left',
  flush: false,
};

export default Label;
